module.exports = __webpack_public_path__ + "static/media/ai-grid-download.b4eb6be7.jpg";